<template>
  <h1>Einlagerung</h1>
  <div v-if="overviewInbound()">
    <section
        v-for="regrater in regraters()"
        :key="regrater.contactId">
      <h2>{{ regrater.name }}</h2>
      <ul class="list mb-0">
        <li v-for="(detail, index) in getInboundByRegrater(regrater.contactId)"
            :key="index"
            class="row">
          <div class="col-5">
            <router-link :to="{ name: 'LoadingShow', params: { id: detail.incomingId }}">
              <b>{{ detail.slipNumber }}</b>
              {{ productName(detail.productId) }}
            </router-link>
          </div>
          <div class="col-2 text-right">{{ parseAmount(detail.totalWeight) }} t</div>
          <div class="col-1 d-flex justify-content-center align-items-start pt-2">
            <div v-if="detail.sentMail_regrater"
                 class="dot green"></div>
            <input v-else
                   type="checkbox" @change="toggleSendMail('inbound', detail.incomingId, $event)"/>
          </div>
        </li>
      </ul>
      <div class="row mb-4">
        <div class="col-4 bold">Summe</div>
        <div class="col-3 bold text-right">{{ parseAmount(inboundRegraterTotal(regrater.contactId)) }} t</div>
      </div>
    </section>
  </div>

  <h1>Auslagerung</h1>
  <div v-if="overviewOutbound()">
    <section
        v-for="regrater in regraters()"
        :key="regrater.contactId">
      <h2>{{ regrater.name }}</h2>
      <ul class="list mb-0">
          <li v-for="(detail, index) in getOutboundByRegrater(regrater.contactId)"
              :key="index"
              class="row">
            <div class="col-5">
              <router-link :to="{ name: 'LoadingShow', params: { id: detail.loadingId }}">
                <b>{{ detail.deliverySlipNumber }}</b>
                {{ productName(detail.productId) }}
              </router-link>
            </div>
            <div class="col-2 text-right">{{ parseAmount(detail.loadingWeight) }} t</div>
            <div class="col-1 d-flex justify-content-center align-items-start pt-2">
              <div v-if="detail.loadedSentMail"
                   class="dot green"></div>
              <input v-else
                     type="checkbox" @change="toggleSendMail('outbound', detail.loadingId, $event)"/>
            </div>
          </li>
      </ul>
      <div class="row mb-4">
        <div class="col-4 bold">Summe</div>
        <div class="col-3 bold text-right">{{ parseAmount(outboundRegraterTotal(regrater.contactId)) }} t</div>
      </div>
    </section>
  </div>

  <button v-if="sendMailsCount" @click="sendMails" type="button" class="mt-1" :disabled="storing">An Aufkäufer senden</button>

  <app-btn-back class="pt-2"/>
</template>

<script>
export default {
  name: "OverviewPage",
  data() {
    return {
      sendMailIds: {
        'inbound': [],
        'outbound': []
      },
      sendMailsCount: 0,
      storing: false,
    }
  },
  async created() {
    this.$store.state.vessel = []
    await this.$store.dispatch('getItemList', { entityName: 'incoming', method: 'overview'} )
    await this.$store.dispatch('getItemList', { entityName: 'loading', method: 'overview'} )
    await this.$store.dispatch('initItems', {entityName: 'product'})

    await this.$store.dispatch('getItemList', {entityName: 'report', method: 'overview'})
    await this.$store.dispatch('initItems', {entityName: 'supplier'})
    await this.$store.dispatch('initItems', {entityName: 'regrater'})
  },
  methods: {
    overviewInbound() {
      return this.$store.state.incoming
    },
    getInboundByRegrater(regraterId) {
      return this.$store.state.incoming.filter(e => e.regraterId == regraterId)
    },
    inboundRegraterTotal(regraterId) {
      const entries = this.getInboundByRegrater(regraterId)
      if (entries.length === 0) return 0
      return entries.reduce((acc, entry) => acc + parseFloat(entry.totalWeight), 0)
    },
    overviewOutbound() {
      return this.$store.state.loading
    },
    getOutboundByRegrater(regraterId) {
      return this.$store.state.loading.filter(e => e.regraterId == regraterId)
    },
    outboundRegraterTotal(regraterId) {
      const entries = this.getOutboundByRegrater(regraterId)
      if (entries.length === 0) return 0
      return entries.reduce((acc, entry) => acc + parseFloat(entry.loadingWeight), 0)
    },
    productName(productId) {
      const product = this.$store.state.product.find(e => e.productId === productId)
      if (product) return product.name
      else return ""
    },
    parseAmount(amount) {
      amount = parseFloat(amount) / 1000

      return amount.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
    },
    toggleSendMail(type, id, event) {
      this.sendMailIds[type][id] = event.target.checked
      if (event.target.checked) this.sendMailsCount++
      else this.sendMailsCount--
    },
    async sendMails() {
      let response
      this.storing = true

      // inbound
      const inbound = this.sendMailIds.inbound.reduce((acc, val, id) => {
        if (val === true) acc.push(id)
        return acc
      }, [])
      if (inbound.length > 0) {
        response = await this.$store.dispatch('cruItem',
            { name: 'incoming', id: 1, data: {'sendMailIds': inbound.join(',') }})
        if (response && response.success) {
          for (let id of inbound) {
            this.$store.state.incoming.find(e => e.incomingId == id).sentMail_regrater = true
          }
          this.sendMailIds.inbound = []
        }
      }

      // outbound
      const outbound = this.sendMailIds.outbound.reduce((acc, val, id) => {
        if (val === true) acc.push(id)
        return acc
      }, [])
      if (this.sendMailIds.outbound.find(e => e === true)) {
        response = await this.$store.dispatch('cruItem',
            { name: 'loading', id: 1, data: {'sendMailIds': outbound.join(',') }})
        if (response && response.success) {
          for (let id of outbound) {
            this.$store.state.loading.find(e => e.loadingId == id).loadedSentMail = true
          }
          this.sendMailIds.outbound = []
        }
      }
      this.storing = false
    },
    regraters() {
      return this.$store.state.regrater
    },
  }
}
</script>

<style scoped>
h2 {
  padding-top: 0.5rem;
}

.subnav li:after {
  margin-left: -16px;
}
</style>